import { queryClient } from "@provider/query-client";
import api, { methods } from "@api";
import { useSuspenseQuery } from "@tanstack/react-query";
import type { HistoryOrder } from "@type/orders";

type OrderParams = {
  oid: string;
  round: string;
};

const getQueryFn = (params: OrderParams) =>
  api<HistoryOrder[]>({
    path: "/account/order-by-id",
    method: methods.POST,
    params,
  });

function getQueryKey(params: OrderParams) {
  const arrayOfValues = Object.values(params || {});
  return ["order-detail", ...arrayOfValues];
}

export function prefetchOrderDetail(params: OrderParams) {
  queryClient.prefetchQuery({
    queryKey: getQueryKey(params),
    queryFn: () => getQueryFn(params),
    // 30 seconds
    staleTime: 30 * 1000,
  });
}
export function useOrder(params: OrderParams) {
  return useSuspenseQuery({
    queryKey: getQueryKey(params),
    queryFn: () => getQueryFn(params),
  });
}
